const initTabs = components => {
  if (!components) {
    return;
  }

  [...components].forEach(component => {
    const tabList = component.querySelector('[role="tablist"]');
    const tabs = component.querySelectorAll('[role="tab"]');
    const tabPanels = component.querySelectorAll('[role="tabpanel"]');

    let tabsIndex = 0;

    const firstTab = tabList.querySelector('[role="tab"]');
    const firstTabPanel = component.querySelector('[role="tabpanel"]');

    if (firstTab && firstTabPanel) {
      firstTab.setAttribute("aria-selected", true);
      firstTabPanel.setAttribute("aria-hidden", false);
    }

    tabs.forEach(tab => {
      tab.addEventListener("click", () => {
        changeTabs(tab);
      });
    });

    tabList.addEventListener("keydown", event => {
      if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") {
        return;
      }

      tabs[tabsIndex].setAttribute("tabtabsIndex", -1);

      if (event.key === "ArrowRight") {
        tabsIndex++;

        if (tabsIndex >= tabs.length) {
          tabsIndex = 0;
        }
      }

      if (event.key === "ArrowLeft") {
        tabsIndex--;

        if (tabsIndex < 0) {
          tabsIndex = tabs.length - 1;
        }
      }

      tabs[tabsIndex].setAttribute("tabtabsIndex", 0);
      tabs[tabsIndex].focus();
      changeTabs(tabs[tabsIndex]);
    });

    const changeTabs = nextTab => {
      tabs.forEach(tab => {
        if (tab === nextTab) {
          tab.setAttribute("aria-selected", true);
          tab.setAttribute("tabindex", 0);
        } else {
          tab.setAttribute("aria-selected", false);
          tab.setAttribute("tabindex", -1);
        }
      });

      tabPanels.forEach(tabPanel => {
        tabPanel.setAttribute("aria-hidden", true);
      });

      component
        .querySelector(`#${nextTab.getAttribute("aria-controls")}`)
        .setAttribute("aria-hidden", false);
    };
  });
};

export default initTabs;
